import { c as _c } from "react/compiler-runtime";
import { useMemo } from "react";
import { useTokenMetadataQuery } from "@/hooks/useAlchemyNftQueries";
import type { SupportedChain, TokenMetadata } from "@/components/nft-picker/NftPicker.types";
import { EMPTY_METADATA_MAP } from "../utils";
import type { TokenWindowEntry } from "../types";
type TokenMetadataWindowParams = Readonly<{
  contractAddress?: `0x${string}` | undefined;
  chain: SupportedChain | null;
  windowTokens: TokenWindowEntry[];
}>;
export function useTokenMetadataWindow(t0) {
  const $ = _c(13);
  const {
    contractAddress,
    chain,
    windowTokens
  } = t0;
  let t1;
  if ($[0] !== windowTokens) {
    t1 = windowTokens.map(_temp);
    $[0] = windowTokens;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const decimalTokenIds = t1;
  const canLoadMetadata = Boolean(contractAddress && chain && decimalTokenIds.length > 0);
  const t2 = chain ?? undefined;
  let t3;
  if ($[2] !== canLoadMetadata || $[3] !== contractAddress || $[4] !== decimalTokenIds || $[5] !== t2) {
    t3 = {
      address: contractAddress,
      chain: t2,
      tokenIds: decimalTokenIds,
      enabled: canLoadMetadata
    };
    $[2] = canLoadMetadata;
    $[3] = contractAddress;
    $[4] = decimalTokenIds;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  const metadataQuery = useTokenMetadataQuery(t3);
  let t4;
  if ($[7] !== canLoadMetadata || $[8] !== metadataQuery.data) {
    bb0: {
      if (!canLoadMetadata) {
        t4 = EMPTY_METADATA_MAP;
        break bb0;
      }
      const entries = metadataQuery.data ?? [];
      if (!entries.length) {
        t4 = EMPTY_METADATA_MAP;
        break bb0;
      }
      const map = new Map();
      for (const entry of entries) {
        map.set(entry.tokenIdRaw, entry);
        map.set(entry.tokenId.toString(10), entry);
      }
      t4 = map;
    }
    $[7] = canLoadMetadata;
    $[8] = metadataQuery.data;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  const metadataMap = t4;
  let t5;
  if ($[10] !== metadataMap || $[11] !== metadataQuery) {
    t5 = {
      metadataQuery,
      metadataMap
    };
    $[10] = metadataMap;
    $[11] = metadataQuery;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  return t5;
}
function _temp(token) {
  return token.decimalId;
}